import { useEffect, useState } from 'react';

/**
 * Debounces rapidly changing values (e.g. text filters) to reduce re-renders.
 */
export const useDebouncedValue = (value, delay = 250) => {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = window.setTimeout(() => setDebounced(value), delay);
    return () => window.clearTimeout(timer);
  }, [value, delay]);

  return debounced;
};

